<template>
  <pt-deposit-settlement class="pt-deposit-settlement__page"></pt-deposit-settlement>
</template>

<script>
import PtDepositSettlement from 'cps/new-to-old-audit/pt-deposit-settlement/withData'
export default {
  name: 'pt-deposit-settlement__view',
  components: {
    'pt-deposit-settlement': PtDepositSettlement
  }
}
</script>
